import * as React from "react";
import { cn } from "@/lib/utils";

export interface SectionHeadProps extends React.HTMLAttributes<HTMLElement> {
  num?: string | number;
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

const SectionHead = React.forwardRef<HTMLElement, SectionHeadProps>(
  ({ num, eyebrow, title, description, actions, className, ...props }, ref) => {
    return (
      <header
        ref={ref}
        className={cn("flex items-start justify-between gap-4 pb-4", className)}
        {...props}
      >
        <div className="min-w-0 flex-1">
          {(num !== undefined || eyebrow) && (
            <div className="mb-1 flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-muted-foreground">
              <span aria-hidden className="h-px w-6 bg-brand-accent" />
              {num !== undefined && (
                <span className="font-serif text-sm italic text-brand-accent normal-case tracking-normal">
                  {num}
                </span>
              )}
              {eyebrow && <span>{eyebrow}</span>}
            </div>
          )}
          <h2 className="font-serif text-2xl font-normal leading-tight tracking-tight text-foreground">
            {title}
          </h2>
          {description && (
            <p className="mt-1.5 text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </header>
    );
  },
);
SectionHead.displayName = "SectionHead";

export { SectionHead };